import React, { FC } from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import { useTheme } from "@material-ui/core";

type Props = {
  hovering?: boolean;
  hoveringFill: string;
};

const CircleArrowIcon: FC<SvgIconProps & Props> = props => {
  const theme = useTheme();
  const { hovering, hoveringFill, ...rest } = props;

  return (
    <SvgIcon {...rest} width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <path
          id="prefix__a"
          d="M14.81 11.278c.121.14.19.331.19.53v.38c-.002.198-.07.388-.19.53l-4.452 5.13c-.081.095-.192.148-.308.148-.115 0-.226-.053-.307-.148l-.615-.71c-.081-.092-.127-.218-.127-.35 0-.132.046-.258.127-.35l3.854-4.44-3.854-4.44C9.046 7.464 9 7.336 9 7.203c0-.133.046-.261.128-.355l.615-.7c.081-.095.192-.148.307-.148.116 0 .227.053.308.148l4.451 5.13z"
        />
      </defs>
      <g fill={hovering ? hoveringFill : "none"} fillRule="evenodd">
        <circle
          cx="12"
          cy="12"
          r="11.5"
          stroke={hovering ? hoveringFill : theme.palette.primary.main}
        />
        <use fill={theme.palette.primary.main} href="#prefix__a" />
      </g>
    </SvgIcon>
  );
};

export default CircleArrowIcon;
